import { StrictMode, useEffect } from "react";
import { createRoot } from "react-dom/client";
import ExcalidrawApp from "./excalidraw-app";
import { getLocationQuery } from "./utils";
import {
  intializeTokenClient,
  downloadDriveFile,
  getDriveFileMetadata,
  initCodeClient,
  initTokenClient,
  uploadToDrive,
  createFolder,
  getFolder,
} from "./data/upload_drive";
import "./excalidraw-app/pwa";
import "./excalidraw-app/sentry";
import { getAddonUserStatus, getPassport, loginAddon } from "./loginPay/login_pay";
import { message } from 'antd';

declare var google: any;
declare var gapi: any;

declare var passport: any;
declare var window: any;
declare var google_uid: any;


window.__EXCALIDRAW_SHA__ = process.env.REACT_APP_GIT_SHA;
const rootElement = document.getElementById("root")!;
const root = createRoot(rootElement);
function App() {
  const getDriveFile = async function ({
    state,
    file = "",
    _access_token = "",
  }: {
    state: any;
    file: any;
    _access_token: any;
  }) {
    let token: any = null;
    if (_access_token) {
      token = _access_token;
    }
    let fileId: any = null;
    if (file) {
      fileId = file.id;
    } else if (state.ids) {
      fileId = state.ids[0];
    } else {
      fileId = state.exportIds[0];
    }
    const res: any = file || (await getDriveFileMetadata(fileId, token));

    let fileName: any = res.name;
    let blob: any = null;
    if (file || state.ids) {
      blob = await downloadDriveFile(fileId, token, res.mimeType);
    } else {
      // blob = await exportDriveFile(fileId, token);
    }
    let fileBlob: any = blob;


    // 创建一个 FileReader 对象来读取 Blob 数据
    var reader = new FileReader();
    // 设置 FileReader 的 onload 事件处理程序
    reader.onload = function (event: any) {
      // 读取的数据存储在 event.target.result 中
      var data = JSON.parse(event.target.result);
      function deepConcatNumericValues(obj: any) {
        let result = '';

        for (const key in obj) {
          if (obj.hasOwnProperty(key)) {
            // 检查键是否为数字字符串
            if (/^\d+$/.test(key)) {
              const value = obj[key];
              if (typeof value === 'object' && value !== null) {
                // 如果值是对象，则递归调用该函数
                result += deepConcatNumericValues(value);
              } else {
                // 如果值不是对象，则将其拼接到结果字符串中
                result += String(value);
              }
            }
          }
        }

        return result;
      }
      const concatenatedString = deepConcatNumericValues(data);
      localStorage.setItem("excalidraw", concatenatedString)
      // 获取当前页面的 URL
      const currentUrl = window.location.href;
      // 删除查询参数
      const urlWithoutQuery = currentUrl.split('?')[0]; // 获取不包含查询参数的部分
      // 跳转到新的 URL
      window.location.href = urlWithoutQuery;
    };
    // 读取 Blob 数据
    reader.readAsText(fileBlob);
    // 将 Blob 转换为文本
    // uploadAliOss(fileBlob, fileName);
  };

  // 显示登录信息
  let hasShowLoginMessage = false;
  // 显示订阅信息
  let hasShowSubscribeMessage = false;

  let addOnUser: any = null;
  let passport: any = null;

  let loopLoginCounter = 1;
  let loopSubscribeCounter = 1;


  // 获取用户
  function getUserProfile(type: any) {
    return new Promise((resolve, reject) => {
      getAddonUserStatus(passport).then((userStatus) => {
        // window.g_user_status = userStatus;
        (window as any).g_user_status = 1;
        console.log(userStatus, "userstatus!!")
        let { profile, subscription } = userStatus;
        if (profile) {
          let { free_cnt, is_subscribed, detail } = subscription;
          if (!free_cnt) free_cnt = 0;
          if (detail && detail.ends_at) is_subscribed = new Date(detail.ends_at) > new Date();
          const _user = { ...profile, free_cnt, is_subscribed, subscribedType: is_subscribed && detail.name || '' };
          // window.user = _user;
          (window as any).user = _user;
          (window as any).userStatus = _user;


          if (type == 'login' && !hasShowLoginMessage) {
            message.success('login successful', 10);
            hasShowLoginMessage = true;
          } else if (type == 'subscribed' && is_subscribed && !hasShowSubscribeMessage) {
            message.success('Subscription successful', 10);
            hasShowSubscribeMessage = true;
          }
        }
        resolve(1);
      }, (error) => {
        reject(1);
      })
    })
  }
  // 登录
  async function handleLogin() {
    try {
      // const res = await getPassport();
      // console.log("getPassport", res);
      // passport = res.passport;
      // localStorage.setItem("login_passport", passport);
      window.open(
        process.env.NODE_ENV == "development"
          ? "https://www.livepolls.app/collaborative_whiteboard/login"
          : `https://www.livepolls.app/collaborative_whiteboard/login?passport=` +
          '' +
          "&user_id=" +
          (window.google_uid || "")
      );
      setTimeout(() => {
        loopLoginCounter = 1;
        loopLogin();
      }, 5000);
    } catch (error) {
      console.log(error, "在try中报错了")
    }
  }
  window.handleLogin = handleLogin
  // 轮询登录
  async function loopLogin() {
    console.log("轮询登录")
    try {
      await getUserProfile('login');
      console.log(window.userstatus, "用户信息")
      console.log(loopLoginCounter)
      if (!window.userStatus && loopLoginCounter < 60) {
        setTimeout(() => {
          loopLoginCounter++;
          loopLogin();
        }, 3000)
      }
    } catch (error) {
    }
  }
  // 处理订阅
  function handleSubscribe() {
    window.open(process.env.NODE_ENV == "development" ? 'http://localhost:8080/src/nested/pricing/index.html' : `https://www.livepolls.app/collaborative_whiteboard/pricing?user_id=` + (window.google_uid || ''));
    setTimeout(() => {
      loopSubscribeCounter = 1;
      loopSubscribe();
    }, 5000)
  }
  window.handleSubscribe = handleSubscribe
  // 轮询订阅
  async function loopSubscribe() {
    try {
      await getUserProfile('subscribed');
      if ((!window.user || window.user.is_subscribed) && loopSubscribeCounter < 90) {
        setTimeout(() => {
          loopSubscribeCounter++;
          loopSubscribe();
        }, 3000)
      }
    } catch (error) {
    }
  }
  useEffect(() => {
    async function getUser() {
      getUserProfile(1);
    }
    getUser()


    async function async_fun() {
      let query = await getLocationQuery();
      if (query.state) {
        // 开启一个loading 等功能跑通再加
        const res: any = await initTokenClient();
        let token = null;
        if (res.access_token) {
          token = res.access_token;
        } else if (true) {
          token = gapi.auth.getToken().access_token;
        }
        getDriveFile({
          state: JSON.parse(query.state),
          file: "",
          _access_token: res.access_token,
        });
      } else if (query.url) {
        console.log(query.url, "query.url")
      }
    }

    async_fun();
  }, []);

  return (
    <StrictMode>
      <ExcalidrawApp/>
    </StrictMode>
  );
}

root.render(<App />);
